<template>

    <div class="row mb-5">
        <section-headline msg="Mein Markt"></section-headline>

        <div class="col-12 col-lg-4 mb-5 mb-lg-0">
            <ul class="list-group list-group-flush">
                <market-sidebar v-for="(item, key) in myOptions"
                                :key="key"
                                :class="activeTab.value === key ? ' active' : ''"
                                :icon="item.icon"
                                :itemKey="key"
                                :text="item.text"
                                @click="changeTab"></market-sidebar>
            </ul>
        </div>
        <market-content :activeTab="activeTab"></market-content>
    </div>

</template>

<script>
import MarketSidebar from './MarkeSidebar';
import MarketContent from './MarketContent';

export default {
    name: 'Market',
    components: {MarketContent, MarketSidebar},
    props: {
        merchant: Object,
    },
    data() {
        return {
            myOptions: {
                regionalGoods: {
                    text: 'Aus\'m Dorf',
                    icon: 'church',
                },
                offers: {
                    text: 'Angebote',
                    icon: 'badge-percent',
                },
                regionalServices: {
                    text: 'Persönliches Extras',
                    icon: 'crown',
                },
                nationalServices: {
                    text: 'Nationale Extras',
                    icon: 'globe',
                },
                leaflets: {
                    text: 'Flugblätter',
                    icon: 'newspaper',
                },
                vouchers: {
                    text: 'Gutscheine',
                    icon: 'percentage',
                },
                brands: {
                    text: 'Marken',
                    icon: 'star',
                },
                about: {
                    text: 'Über Uns',
                    icon: 'address-card',
                },
                gallery: {
                    text: 'Galerie',
                    icon: 'images',
                },
                jobs: {
                    text: 'Jobs',
                    icon: 'address-book',
                },
            },
            activeTab: {
                value: '',
                icon: '',
                text: '',
            },
        };
    },
    methods: {
        changeTab(value) {
            this.activeTab.text = value[0];
            this.activeTab.value = value[1];
            this.activeTab.icon = value[2];
        },
    },

    mounted() {
        const tmpKey = Object.keys(this.myOptions)[0];
        const tmpObj = this.myOptions[tmpKey];

        this.activeTab.value = tmpKey;
        this.activeTab.icon = tmpObj.icon;
        this.activeTab.text = tmpObj.text;
    },
};
</script>
